import { render, staticRenderFns } from "./GuestLogin.vue?vue&type=template&id=c6b04b06&scoped=true"
import script from "./GuestLogin.vue?vue&type=script&lang=js"
export * from "./GuestLogin.vue?vue&type=script&lang=js"
import style0 from "./GuestLogin.vue?vue&type=style&index=0&id=c6b04b06&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b04b06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6b04b06')) {
      api.createRecord('c6b04b06', component.options)
    } else {
      api.reload('c6b04b06', component.options)
    }
    module.hot.accept("./GuestLogin.vue?vue&type=template&id=c6b04b06&scoped=true", function () {
      api.rerender('c6b04b06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/pages/login/GuestLogin.vue"
export default component.exports